<template>
  <li>
    <span
      v-show="!nextLevelIsLeaf"
      class="icon pointer"
      @click="toggle(value.id)">

      <i
        class="fas"
        :class="isExpanded ? 'fa-caret-down' : 'fa-caret-right'">
      </i>
    </span>

    <span
      class="pointer"
      @click="toggle(value.id)">

      {{ value.value}}
    </span>

    <ul :class="{ 'is-hidden': !isExpanded }">
      <li v-if="isLoading || isEmpty"><em>{{ itemPlaceholder }}</em></li>

      <template v-else>
        <li class="has-text-weight-bold">{{ column.tabname }}</li>

        <page-tree-item
          v-for="(child, idx) in children"
          :key="child.id"
          :parents="path"
          :value="child"
          :depth="depth + 1"
          :show="showChildren"
          :last="isLastItem(idx)">
        </page-tree-item>
      </template>
    </ul>
  </li>
</template>

<script>
import { bus } from '@/main'
import { mapGetters } from 'vuex'

export default {
  name: 'PageTreeItem',
  props: {
    parents: {
      type: Array,
      required: true
    },
    value: {
      type: Object,
      required: true
    },
    depth: {
      type: Number,
      required: true
    },
    show: {
      type: Boolean,
      required: true
    },
    last: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      children: null,
      isExpanded: false,
      showChildren: false
    }
  },
  computed: {
    ...mapGetters({
      page: 'pages/page'
    }),
    nextColumn () {
      return this.page.columns[this.depth + 1]
    },
    path () {
      return this.parents.concat(this.value.id)
    },
    isLeafItem () {
      return this.path.length === this.page.columns.length
    },
    column () {
      return this.page.columnProperties.find(x => x.id === this.page.columns[this.depth + 1])
    },
    params () {
      return {
        pageId: this.page.id,
        bundleId: this.$route.params.bundleId
      }
    },
    nextLevelIsLeaf () {
      return this.depth === this.page.columns.length - 2
    },
    isLoading () {
      return this.children === null
    },
    isEmpty () {
      return (this.children) ? this.children.length === 0 : false
    },
    itemPlaceholder () {
      return (this.isLoading) ? 'Items worden geladen' : `Geen ${this.column.tabname} gevonden`
    }
  },
  created () {
    if (this.mode === 'grid') {
      bus.$emit('setPath', this.path)
    }
  },
  watch: {
    isExpanded () {
      if (this.value.children.length === 0) {
        this.fetchChildren(this.value.id)
      }
    }
  },
  methods: {
    toggle () {
      if (!this.nextLevelIsLeaf) {
        this.isExpanded = !this.isExpanded

        bus.$emit('closeContent')
      } else {
        bus.$emit('showContent', { path: this.path })
      }
    },
    isSelected (valueId) {
      return this.path[this.path.length - 1] === valueId
    },
    getColumn (columnId) {
      return this.page.columnProperties.find(x => x.id === columnId)
    },
    toggleChildren () {
      this.showChildren = !this.showChildren
    },
    fetchChildren () {
      let self = this

      let params = {
        path: this.path,
        childColumnId: this.nextColumn
      }

      if (this.$route.params.code) {
        params.code = this.$route.params.code
      } else {
        params.pageId = this.page.id
        params.bundleId = this.$route.params.bundleId
      }

      this.$store.dispatch('pages/fetchChildren',
        params
      ).then(
        (res) => {
          self.children = res.children
        }
      )
    },
    isLastItem (idx) {
      return idx + 1 === this.children.length
    }
  }
}
</script>

<style lang="css" scoped>
  ul ul {
    margin-left: 30px;
  }

  .pointer {
    cursor: pointer;
  }
</style>
